export const data = [
  {
    disabled: false,
    text: "All status",
    value: "All"
  },
  {
    disabled: false,
    text: "Configured",
    value: "Configured"
  },
  {
    disabled: false,
    text: "Not configured",
    value: "Not Configured"
  }
];
